export const TOGGLE_THEME = Symbol('TOGGLE_THEME')
